import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import RingChart from '../../../charts/echarts/RingChart'
import ChartProvider from '../../../charts/echarts/ChartProvider'
import CustomChart from '../../../charts/echarts/CustomChart'

function PointRing ({
  min,
  max,
  color,
  // fontSize,
  value,
  startAngle,
  endAngle,
  ringSeriesId,
  pointSeriesId,
  chartProviderProps
}) {
  const ringOptions = useMemo(() => {
    return {
      // seriesId: 'overallScore',
      // colorBy: 'series',
      // height: 250,
      // width: 250,
      startAngle: 90,
      endAngle: -270,
      radius: '100%',
      // markPoint: {},
      progress: {
        show: false
      },
      axisLine: {
        show: true,
        lineStyle: {
          // width: 20,
          color: [[1, color]],
          opacity: 0.3
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      title: {
        show: false
      },
      detail: {
        show: true,
        offsetCenter: [0, 0],
        color
      },
      anchor: {
        show: false
        // icon: 'circle'
      }
    }
  }, [color])

  const pointOptions = useMemo(() => {
    return {
      coordinateSystem: null
    }
  }, [])

  const renderItem = useCallback((params, api) => {
    // // eslint-disable-next-line no-debugger
    // debugger
    const width = api.getWidth()
    const height = api.getHeight()
    const cx = width / 2
    const cy = height / 2
    const outerRadius = Math.min(width, height) / 2
    const arcRadius = outerRadius - 10 / 2

    // const radius = Math.min(width, height) * 0.4 // Matches gauge radius (80% of smaller dim * 0.5)

    // Calculate angle for the value
    const angleDeg = startAngle + ((value - min) / (max - min)) * (startAngle - endAngle)
    const angle = (angleDeg * Math.PI) / 180

    const x = cx + arcRadius * Math.cos(angle)
    const y = cy - arcRadius * Math.sin(angle) // Y is flipped in canvas

    return {
      type: 'circle',
      shape: {
        cx: x,
        cy: y,
        r: 8
      },
      style: {
        fill: color
      }
    }
  }, [color, endAngle, max, min, startAngle, value])

  return (
    <ChartProvider {...chartProviderProps}>
      <RingChart
        seriesId={ringSeriesId}
        data={[{ value }]}
        {...ringOptions}
      />
      <CustomChart
        seriesId={pointSeriesId}
        data={[value]}
        renderItem={renderItem}
        {...pointOptions}
      />
    </ChartProvider>
  )
}

PointRing.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  color: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.number,
  startAngle: PropTypes.number,
  endAngle: PropTypes.number,
  ringSeriesId: PropTypes.string,
  pointSeriesId: PropTypes.string,
  chartProviderProps: PropTypes.object
}

PointRing.defaultProps = {
  min: 0,
  max: 100
}

export default PointRing
